import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ProfessionalForm from "./ProfessionalForm";

export default function ProfessionalModal({ prof, onClose }) {
  const [showForm, setShowForm] = useState(false);

  return (
    <AnimatePresence>
      {prof && !showForm && (
        <motion.div
          className="fixed inset-0 bg-black/65 flex items-center justify-center z-50 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="bg-white rounded-2xl w-full max-w-2xl p-6 relative shadow-2xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-600 hover:text-black"
            >
              ✕
            </button>

            <div className="flex flex-col md:flex-row items-center gap-6">
              <img
                src={prof.image}
                alt={prof.name}
                className="w-36 h-36 rounded-full object-cover shadow-md"
              />
              <div>
                <h3 className="text-2xl font-semibold text-primary">{prof.name}</h3>
                <p className="text-sm text-gray-600 mb-2">{prof.position}</p>
                <p className="text-sm text-gray-600 mb-2">{prof.estudio}</p>
                <p className="text-gray-700 mb-3">{prof.description}</p>
                {prof.contact && (
                  <p className="text-sm text-gray-600">✉️ {prof.contact}</p>
                )}
                {prof.phone && (
                  <p className="text-sm text-gray-600">📞 {prof.phone}</p>
                )}
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setShowForm(true)}
                className="px-4 py-2 rounded-md border border-gray-200 hover:bg-gray-50"
              >
                Enviar email
              </button>

              <button
                onClick={onClose}
                className="px-4 py-2 rounded-md bg-primary text-white hover:bg-[#025c0f]"
              >
                Cerrar
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}

      {showForm && (
        <motion.div
          className="fixed inset-0 bg-black/65 flex items-center justify-center z-50 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setShowForm(false)}
        >
          <motion.div
            className="bg-white rounded-2xl w-full max-w-lg p-6 relative shadow-2xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowForm(false)}
              className="absolute top-4 right-4 text-gray-600 hover:text-black"
            >
              ✕
            </button>

            <ProfessionalForm
              professional={{
                name: prof.name,
                email: prof.contact,
              }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
